import { CommonModule } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { IImage } from '@core/interfaces/booking.interface';
import { SignedUrlPipe } from '@core/pipes/signed-url.pipe';

@Component({
  selector: 'app-dot-slider',
  imports: [SignedUrlPipe, CommonModule],
  standalone: true,
  templateUrl: './dot-slider.component.html',
  styleUrl: './dot-slider.component.scss',
})
export class DotSliderComponent {
  @Input() public images: IImage[] | string[] = [];
  @Input() public dots: number = 0;

  public dotsRange!: number[];
  public finalDots: number = 0;
  public curIndex: number = 0;
  public isIImage: boolean = false;

  public get image(): IImage {
    return this.images[this.curIndex] as IImage;
  }

  public get src(): string {
    return this.images[this.curIndex] as string;
  }

  public ngOnInit() {
    this.updateSlider();
  }

  public ngOnChanges(changes: SimpleChanges) {
    this.updateSlider();
  }

  public setImageByDot(index: number): void {
    this.curIndex = index;
    const firsIndex = this.dotsRange[0];
    const lastIndex = this.dotsRange[this.dotsRange.length - 1];
    if (index === lastIndex && lastIndex < this.images.length - 1) {
      this.setDotsRange(firsIndex + 1, lastIndex + 1);
    }
    if (index === firsIndex && index > 0) {
      this.setDotsRange(firsIndex - 1, lastIndex - 1);
    }
  }

  public setDotsRange(firstIndex: number, lastIndex: number): void {
    this.dotsRange = [];
    for (let i = firstIndex; i <= lastIndex; ++i) {
      this.dotsRange.push(i);
    }
  }

  private updateSlider(): void {
    this.isIImage = !!this.images.length && typeof this.images[0] !== 'string';
    this.finalDots =
      this.images.length > this.dots ? this.dots : this.images.length;
    this.setDotsRange(0, this.finalDots - 1);
  }
}
